<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="form-group row mb-3">
                <div class="col-md-3">
                    <app-select-academic-year-only
                    (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                            [academic_year]="this.paramForm.get('academic_year')?.value"
                            (schoolLevelRelationChanged)="onChangeSchoolLevel($event)"
                            [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-3">
                    <app-select-school-program
                    [academic_year]="this.paramForm.get('academic_year')?.value"
                    [school_location_id]="this.paramForm.get('school_location_id')?.value"
                    [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                    (schoolProgramChanged)="onChangeSchoolProgram($event)">
                    </app-select-school-program>
                </div>
                <div class="col-md-3">
                    <ng-select (change)="onChangePeriod($event)"
                        [(ngModel)]="periodSelected"
                        [items]="periodList"
                        bindLabel="name"
                        bindValue="period_id"
                        [placeholder]= "periodSelected ? '' : 'Select Period'"
                        class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">{{item.name}}</div>
                        </ng-template>
                    </ng-select>
                </div>
<!--                <div class="col-md-3">-->
<!--                    <app-select-school-program-category-->
<!--                    [school_program_id]="this.paramForm.get('school_program_id')?.value"-->
<!--                    [isDisabled]="!this.paramForm.get('school_program_id')?.value"-->
<!--                    [all]="true"-->
<!--                    (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event)">-->
<!--                    </app-select-school-program-category>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                    <app-select-school-activity-->
<!--                    (schoolActivityChanged)="onChangeSchoolProgramActivity($event)"-->
<!--                    [academic_year]="this.paramForm.get('academic_year')?.value"-->
<!--                    [school_program_id]="this.paramForm.get('school_program_id')?.value"-->
<!--                    [school_program_category_id]="this.paramForm.get('school_program_category_id')?.value"-->
<!--                    [isDisabled]="!paramForm.get('school_program_id')?.value">-->
<!--                    </app-select-school-activity>-->
<!--                </div>-->
            </div>
            <div class="form-group row mb-3">
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>Search</mat-label>
                        <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="Search student name...">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>Payment Method</mat-label>
                        <mat-select [(ngModel)]="isManualPayment" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Manual</mat-option>
                            <mat-option [value]="false">Virtual Account</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>Paid</mat-label>
                        <mat-select [(ngModel)]="filterPaid" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="margin-top:70px">
                <mat-spinner></mat-spinner>
            </div>
            <div>
                <app-status-no-data [show]="data.length === 0 && !loading"></app-status-no-data>
            </div>
            <div class="table-responsive">
                <table mat-table *ngIf="data.length > 0 && !loading"
                       [dataSource]="data" multiTemplateDataRows
                       >
                    <ng-container matColumnDef="school_program_name">
                        <th mat-header-cell *matHeaderCellDef (click)="onSort('school_program_name')" class="cursor-pointer"> School Program</th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.school_program_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activity_name">
                        <th mat-header-cell *matHeaderCellDef (click)="onSort('activity_name')" class="cursor-pointer"> Activity Name</th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.activity_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="student_name">
                        <th mat-header-cell *matHeaderCellDef> Student Name </th>
                        <td mat-cell *matCellDef="let element" class="example-element-name">
                            {{element.student_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="period">
                        <th mat-header-cell *matHeaderCellDef> Period </th>
                        <td mat-cell *matCellDef="let element" class="example-element-name">
                            {{element.period_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element" class="example-element-name">
                            {{element.created_at | date: 'dd/MM/yyyy' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action" *ngIf="auth.permissions['SCHOOL_PROGRAM_REGISTRATION_APPROVER_REJECT'] || auth.permissions['SCHOOL_PROGRAM_REGISTRATION_APPROVER_APPROVE']">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center"> Actions </th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div class="d-flex justify-content-center gap-1">
                                <!-- <button class="btn w-25 no-border" style="color: dodgerblue;" (click)="onOpenModalViewActivity(element)">
                                    View
                                </button>
                                <button class="btn w-25 no-border" style="color: indianred;" (click)="editActivity(element.school_program_activity_id)">
                                    Edit
                                </button> -->
                                <button
                                    class="action-icon-btn action-icon-reject"
                                    (click)="onApproveRegistration(element, false)"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_REGISTRATION_APPROVER_REJECT']"
                                    title="Reject">
                                    <div>
                                        <i-feather name="x" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button
                                    class="action-icon-btn action-icon-approve"
                                    (click)="onApproveRegistration(element, true)"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_REGISTRATION_APPROVER_APPROVE']"
                                    title="Approve">
                                    <div>
                                        <i-feather name="check" class="feather-base"></i-feather>
                                    </div>
                                </button>
                            </div>

                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>&ndash;&gt;
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>
